export const minHeaderWidth = 140;
export const minIconHeaderWidth = 78;
export const checkboxWidth = 40;
export const reportTableRowIconLeftPadding = 80;
export const hasTableRowIconLeftPadding = 40;
export const noTableRowIconLeftPadding = 10;
export const tableColumnResizeCursorClassName = "tableColumnResizeCursor";

// The row icon cells (and the checkbox cell after them) are sticky, the other columns scroll behind them.
// Field cells are shifted right by tableCellOffset (see OuterTableCellStyled), so the sticky area is narrower than the space
// reserved for the row icons by that much, to keep the first column where it was.
export const tableCellOffset = 3;
export const stickyTableRowIconWidth = hasTableRowIconLeftPadding - tableCellOffset;
export const stickyReportTableRowIconWidth = reportTableRowIconLeftPadding - tableCellOffset;
